"use client";

import { useMotionValueEvent, useScroll } from "framer-motion";
import { useRef } from "react";

import MapContainer from "@/components/CityLocation/MapContainer";

import "./CityLocation.css";
import { CityLocationProps, Coords, MapPositionEntry } from "./type";

const legacyCenterConverter = (center: Coords) => {
  return { lat: center.lat, lng: center.lon };
};

const legacyPoiConverter = (poi: MapPositionEntry[]) => {
  const pois = poi?.map((item) => {
    const { lat, lon } = item?.coordinates;
    return {
      position: {
        lat,
        lng: lon,
      },
      icon: `${item?.icon}`,
      title: `${item?.componentName}`,
      place_id: `${item?.placeId}`,
    };
  });
  return pois;
};

export default function CityLocation({ entry }: CityLocationProps) {
  const containerRef = useRef<HTMLDivElement>(null);
  const { scrollYProgress } = useScroll({
    target: containerRef,
  });
  // useMotionValueEvent(scrollYProgress, "change", (latest) => {
  // console.log(latest);
  // });
  return (
    <div
      ref={containerRef}
      className="relative"
      style={{ height: `${entry.ranges.length * 100}lvh`, backgroundColor: entry.background?.value }}
      id="city-location"
    >
      <div className="sticky top-0 h-svh flex flex-col">
        <div className="px-m py-xxl text-center max-w-5xl mx-auto" style={{ color: entry.textColor?.value }}>
          <p className="text-xs font-primary mb-l">{entry.overtitle}</p>
          <h2
            className="text-l md:text-xl mb-l font-primary accent-color accent-font accent-title"
            dangerouslySetInnerHTML={{ __html: entry.title }}
            style={{ color: entry.titleColor?.value }}
          />
          <div className="text-m font-secondary font-secondary-light" dangerouslySetInnerHTML={{ __html: entry.description }} />
        </div>
        <div className="grow">
          <MapContainer
            container={scrollYProgress}
            center={legacyCenterConverter(entry.center)}
            poi={legacyPoiConverter(entry.poi)}
            zoom={entry.zoom}
            ranges={entry.ranges}
            carImage={entry.carImage}
            backgroundColor={entry.background?.value}
            textColor={entry.textColor?.value}
          />
        </div>
      </div>
    </div>
  );
}
